import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    selected_image: {
        marginTop: '10px'
    }
}));

export {useStyles}
